'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var Select = function Select(_a) {
    var className = _a.className,
        name = _a.name,
        children = _a.children,
        label = _a.label,
        _a$id = _a.id,
        id = _a$id === undefined ? (0, _utils.idGen)('select') : _a$id,
        onChange = _a.onChange,
        value = _a.value,
        defaultValue = _a.defaultValue,
        rest = __rest(_a, ["className", "name", "children", "label", "id", "onChange", "value", "defaultValue"]);

    var handleChange = function handleChange(e) {
        var targetValue = e.target.value;

        var newValue = (0, _utils.parse)(targetValue);
        e.preventDefault();
        if (onChange) {
            onChange(newValue);
        }
    };
    return _react2.default.createElement("div", { className: "luna-form__field" }, _react2.default.createElement("label", { className: "luna-label", htmlFor: id }, label), _react2.default.createElement("select", Object.assign({ className: (0, _classnames2.default)(['luna-select', className]), name: name, id: id, onChange: handleChange, value: value && (0, _utils.stringify)(value), defaultValue: defaultValue && !value && (0, _utils.stringify)(defaultValue) }, rest), children));
};
Select.propTypes = {
    children: _propTypes2.default.node.isRequired,
    label: _propTypes2.default.node.isRequired,
    id: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.number]).isRequired,
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.number]).isRequired,
    className: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
};
exports.default = Select;
//# sourceMappingURL=Select.js.map